import PropTypes from "prop-types";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// The gradient-header card used by every Duty Estimator panel, so the tabs stay visually
// consistent with the rest of the admin panel.
function PanelCard({ title, caption, action, children }) {
  return (
    <Card>
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={1}
      >
        <MDBox>
          <MDTypography variant="h6" color="white">
            {title}
          </MDTypography>
          {caption ? (
            <MDTypography variant="caption" color="white" sx={{ opacity: 0.9 }}>
              {caption}
            </MDTypography>
          ) : null}
        </MDBox>
        {action}
      </MDBox>
      {children}
    </Card>
  );
}

PanelCard.defaultProps = { caption: "", action: null, children: null };

PanelCard.propTypes = {
  title: PropTypes.string.isRequired,
  caption: PropTypes.string,
  action: PropTypes.node,
  children: PropTypes.node,
};

export default PanelCard;
